import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Grid, Typography, Box } from '@mui/material';
import { brandColors } from '../../theme/theme';

const formatNumber = (value) => {
  if (value === null || value === undefined) return '0';
  return Number(value).toLocaleString();
};

const formatDate = (value) => {
  if (!value) return 'N/A';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleDateString();
};

const FilmDashboardBanner = ({ stats }) => {
  return (
    <Paper
      sx={{
        p: { xs: 3, md: 4 },
        mb: 3,
        background: brandColors.primary,
        borderRadius: 3,
        border: '2px solid #333',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
      }}
    >
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={2.4}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: brandColors.secondary,
                textShadow: `0 0 20px ${brandColors.secondary}50`,
                mb: 1
              }}
            >
              {formatNumber(stats?.decipher_total_responses)}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#ffffff',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              Total Interviews
            </Typography>
            <Typography variant="body2" sx={{ color: '#e0e0e0', mt: 0.5 }}>
              {stats?.data_source === 'dashboard_api' ? 'Real-time data' : 'Calculated data'}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: brandColors.secondary,
                textShadow: `0 0 20px ${brandColors.secondary}50`,
                mb: 1
              }}
            >
              {formatNumber(stats?.decipher_total_participants)}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#ffffff',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              Unique Participants
            </Typography>
            <Typography variant="body2" sx={{ color: '#e0e0e0', mt: 0.5 }}>
              {stats?.performance_mode === 'fallback' ? 'Fallback mode' : 'Engaged audience'}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: brandColors.secondary,
                textShadow: `0 0 20px ${brandColors.secondary}50`,
                mb: 1
              }}
            >
              {formatDate(stats?.last_survey_date)}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#ffffff',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              Last Survey
            </Typography>
            <Typography variant="body2" sx={{ color: '#e0e0e0', mt: 0.5 }}>
              {stats?.last_refresh ? `Updated ${new Date(stats.last_refresh).toLocaleTimeString()}` : 'Data updated'}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: brandColors.secondary,
                textShadow: `0 0 20px ${brandColors.secondary}50`,
                mb: 1
              }}
            >
              {formatDate(stats?.farthest_release_date)}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#ffffff',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              Tracking Until
            </Typography>
            <Typography variant="body2" sx={{ color: '#e0e0e0', mt: 0.5 }}>
              Future releases
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: brandColors.secondary,
                textShadow: `0 0 20px ${brandColors.secondary}50`,
                mb: 1
              }}
            >
              {formatNumber(stats?.decipher_total_waves)}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#ffffff',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              Survey Waves
            </Typography>
            <Typography variant="body2" sx={{ color: '#e0e0e0', mt: 0.5 }}>
              Continuous tracking
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

FilmDashboardBanner.propTypes = {
  stats: PropTypes.shape({
    decipher_total_responses: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    decipher_total_participants: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    decipher_total_waves: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    last_survey_date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    farthest_release_date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    data_source: PropTypes.string,
    performance_mode: PropTypes.string,
    last_refresh: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
  })
};

FilmDashboardBanner.defaultProps = {
  stats: {}
};

export default FilmDashboardBanner;

